module.exports = __webpack_public_path__ + "img/coin.be900a64.png";